import { AbstractControl, ValidatorFn } from '@angular/forms';

export function dateRangeValidator(fromField: string, toField: string): ValidatorFn {
  return (group: AbstractControl) => {
    const from = group.get(fromField)?.value;
    const to = group.get(toField)?.value;

    if (from && to && new Date(from) > new Date(to)) {
      return { [`invalidDateRange_${fromField}`]: true };
    }
    return null;
  };
}
